var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checklist-group-section default-section"},[(_vm.screen === 'overview')?_c('overview'):_vm._e(),(_vm.screen === 'history')?_c('history'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }